import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { StaffRole } from "../types/auth";

/** Esconde/bloqueia telas por papel, espelhando backend/src/middleware/permissions.ts. */
export function RoleGuard({ allow, children }: { allow: StaffRole[]; children: React.ReactNode }) {
  const { user } = useAuth();
  if (!user || !allow.includes(user.role)) {
    return <Navigate to="/app" replace />;
  }
  return <>{children}</>;
}
